import { Alert } from '@digitools/honest-react';
import React from 'react';
export const UNAUTHORIZED_ALERT = <Alert type={'info'}><strong data-testid={'unauthorized-error'}>Unauthorized!&nbsp;</strong>  User is not authorized to view the requested page. Please contact administrator for further assistance.</Alert>;
